<template>
  <!-- 头部导航 -->
  <header id="header" v-if="showJdoctor">
    <ul class="select ulfl tc" style="position: relative">
      <li
        v-show="systemName === '微天使'"
        style="width: 150px;margin-right: 100px;vertical-align: middle;display: table-cell;height: 60px;"
      >
        <img src="../assets/images/logoing.png" style="vertical-align:middle;" />
      </li>
      <li class="logoIndex" v-show="systemName === '融创绵阳'">
        <img src="../assets/images/logo@2x.png" style="vertical-align:middle;" />
      </li>
      <li @click="toggle(index)" v-for="(tab,index) in tabs" :key="index">
        <router-link
          :to="tab.jump"
          :class="{ border:active === index}"
          v-show="tab.show"
        >{{tab.type}}</router-link>
      </li>

      <li style="font-weight:bold;" :class="{ border:active === 5}">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link" style="color: #ffffff">
             产品矩阵
            <i class="el-icon-caret-bottom el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!--<el-dropdown-item><div @click="loginOut(3)">我的活动</div></el-dropdown-item>-->
            <el-dropdown-item>
              <li class="relative">
                <div class="text">小程序</div>
                <div class="weixin">
                  <p style="margin-top: 34px;">微信扫一扫</p>
                  <p style="margin-bottom: 15px">发现更多精选资源</p>
                  <div class="img">
                    <!-- <img src="../assets/images/weixin.jpg"> -->
                    <img
                      :src="systemName === '融创绵阳'? require('../assets/images/logo_my.jpg'):require('../assets/images/weixin.jpg')"
                    />
                  </div>
                </div>
              </li>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="jumpPage('/superBP')">超级bp</div>
            </el-dropdown-item>
            <el-dropdown-item>
              <li class="relative">
                <div class="text">众创通</div>
                <div class="weixin">
                  <p style="margin-top: 34px;">微信扫一扫</p>
                  <p style="margin-bottom: 15px">发现更多精选资源</p>
                  <div class="img">
                    <!-- <img src="../assets/images/weixin.jpg"> -->
                    <img
                      :src="systemName === '融创绵阳'? require('../assets/images/logo_my.jpg'):require('../assets/images/weixin.jpg')"
                    />
                  </div>
                </div>
              </li>
            </el-dropdown-item>
            <el-dropdown-item divided>
              <div @click="jumpPage('https://dasai.weitianshi.cn/#/index')">创赛通</div>
            </el-dropdown-item>
            <el-dropdown-item divided>
              <div @click="jumpPage('https://www.chuangjiaotong.com/#/index')">创教通</div>
            </el-dropdown-item>
            <el-dropdown-item divided>
              <div @click="jumpPage('https://fa-vc.weitianshi.cn/#/login')">资本大脑</div>
            </el-dropdown-item>
            <el-dropdown-item divided>
              <div @click="jumpPage('https://sp.weitianshi.cn/#/AdminLogin')">精准招商通</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>
<!--      <li style="font-weight:bold;" @click="jumpPage('https://dasai.weitianshi.cn/#/index')">创赛通</li>-->
<!--      <li style="font-weight:bold;" @click="jumpPage('https://fa-vc.weitianshi.cn/#/login')">资本大脑</li>-->
<!--      <li style="font-weight:bold;" @click="jumpPage('https://www.chuangjiaotong.com/#/index')">创教通</li>-->
      <li
        v-show="userRealName"
        style="float: right;position: relative;margin-right: 55px;"
      >
        <el-dropdown trigger="click">
          <span class="el-dropdown-link" style="color: #ffffff">
            {{userRealName}}
            <i class="el-icon-caret-bottom el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!--<el-dropdown-item><div @click="loginOut(3)">我的活动</div></el-dropdown-item>-->
            <el-dropdown-item v-if="wxAppId">
              <div @click="toJoinUpIndex">众创通后台</div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="loginOut(0)">个人信息</div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="loginOut(1)">{{groupStatus}}</div>
            </el-dropdown-item>
            <el-dropdown-item divided>
              <div @click="loginOut(2)">退出</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>

      <li v-show="!userRealName" class="login" @click="login">登录</li>
      <!-- <el-autocomplete
        v-model="companyTitle"
        :fetch-suggestions="querySearchAsync"
        placeholder="查竞品，查工商，请输入公司或品牌名称"
        @select="handleSelect"
        class="width350"
        style="width: 17%"
      ></el-autocomplete>-->
    </ul>
  </header>
</template>

<script type="text/ecmascript-6">
import { mapState } from 'vuex';
import { warning, error } from '@/utils/notification';
export default {
    props: {
        identityDisplay: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            systemName:this.URL.systemName,
            wxAppId:false,
            loading: false,
            tabs: [
                // { type: '首页', jump: '/',show:true },
                // { type: '众创通后台', jump: '/joinUpIndex',show:true }, //小程序定制
                // { type: '项目库', jump: '/projectLibrary',show:true }, //添加项目库
                // { type: '工作站', jump: '/workBench/myProject',show:true },
                // { type: '赛事活动', jump: '/matchActive' ,show:true},
                // { type: '超级BP', jump: '/superBP',show:true }
              { type: '首页', jump: '/',show:true },
              { type: '项目库', jump: '/projectLibrary',show:true }, //添加项目库
              { type: '赛事活动', jump: '/matchActive' ,show:true},
              { type: '工作站', jump: '/workBench/myProject',show:true },
              { type: '众创通后台', jump: '/joinUpIndex',show:true }, //小程序定制
            ],
            restaurants: [],
            companyTitle: '',
            user_name: '',
            timeout: null,
            value: '',
            active: 0,
            showJdoctor: true
        };
    },
    computed: {
        ...mapState({
            groupStatus: state => state.logining.group_name,
            userRealName: state => state.logining.user_real_name,
            user_id: state => state.logining.user_id
        })
    },
    methods: {
      jumpPage(url){
        this.active = 5
        if(url==='/superBP'){
          this.$router.push({
            path: '/superBP'
          });
        }else{
          window.open(url,'_bank')
        }

      },
        // 切换选项卡
        toggle(i) {
            this.active = i;
            if (this.active === 0) {
                this.zgClick('首页');
            }
            if (this.active === 4) {
                this.zgClick('众创通后台');
                  localStorage.entrance = 'joinUpIndex';
                  this.$store.dispatch('setEntrance', 'joinUpIndex');
                  if (localStorage.user_id) {
                    this.$router.push({
                      name: 'joinUpIndex'
                    });

                  } else {
                      this.$router.push({ name: 'telephoneLogin' });
                  }
            }
            if (this.active === 1) {
                this.zgClick('项目库');
            }
            if (this.active === 3) {
                this.zgClick('工作站');
            }

            // 控制点击工作台跳转情况
            if (this.active === 3) {
                localStorage.entrance = 'myProject';
                this.$store.dispatch('setEntrance', 'myProject');
                if (localStorage.user_id) {
                    this.$router.push({
                        name: 'myProject',
                        query: { activeTo: 0 }
                    });
                } else {
                    this.$router.push({ name: 'telephoneLogin' });
                }
            } else if (this.active === 2) {
                localStorage.entrance = 'myMatch';
                this.$store.dispatch('setEntrance', 'myMatch');
                if (localStorage.user_id) {
                    this.$router.push({ name: 'myMatch' });
                } else {
                    this.$router.push({ name: 'telephoneLogin' });
                }
            } else if (this.active === 1) {
                localStorage.entrance = 'projectLibrary';
                this.$store.dispatch('setEntrance', 'projectLibrary');
            }
        },

        // 登录
        login() {
            this.zgClick('登陆');
            localStorage.entrance = 'myProject';
             let cur_path = this.$route.path//获取当前路由
             cur_path = cur_path.substring(1)
             if(cur_path === 'login/'){
               return false
             }
            this.$router.push({ name: 'telephoneLogin' });
        },

        // 获取远程数据模拟
        loadData(arr) {
            var newArr = [];
            for (let i = 0; i < arr.length; i++) {
                let obj = {};
                obj.value =
                    arr[i].project_name === ''
                        ? arr[i].company_name
                        : arr[i].company_name + '(' + arr[i].project_name + ')';
                obj.address = arr[i].com_id;
                obj.company_name = arr[i].company_name;
                obj.pro_id = arr[i].pro_id;
                newArr.push(obj);
            }
            return newArr;
        },

      // 个人信息,认证,登出
      loginOut(e) {
        if (e === 0) {
          this.$router.push({ name: 'personalInformation' }); // 个人信息
        } else if (e === 1) {
          this.getUserGroupByStatus();
        } else if (e === 2) {
          localStorage.clear();
          sessionStorage.clear();
          // this.$router.push({ name: 'telephoneLogin' }); // 登陆
          this.$store.dispatch('setUserRealName', '');
          window.open(this.URL.cst_url + '/#/empty?token=cst&app_id=clear', '_self')
          // setTimeout(() => {
          //   window.location.reload();
          // }, 100);
        } else if (e === 3) {
          this.$router.push({ name: 'myActivity' }); // 我的活动
        }
        this.value = '';
      },

        // 是否认证过身份
        getUserGroupByStatus() {
            // 核对是否认证过身份
            this.$http
                .post(this.URL.getUserGroupByStatus, {
                    user_id: localStorage.user_id
                })
                .then(res => {
                    if (res.data.status_code === 2000000) {
                        if (res.data.status === 0) {
                            this.$router.push({ name: 'identityChoose' });
                            localStorage.authenticate_id = '';
                        } else {
                            // 认证过了
                            localStorage.group_title =
                                res.data.group.group_title || '';
                            this.$emit('identityopen', true);
                        }
                    } else {
                        error('核对身份接口调用失败');
                    }
                });
        },
        getJumpType() {
            //判断地址栏中是否有字符串“jstore”
            let parms = window.location.href.match('jStore');
            if(parms == null) {
                parms = [1];
            }
            if(this.$route.query.source == 'jStore' || this.$route.params.source == 'jStore' || parms[0] == 'jStore'){
                this.showJdoctor = false;
            }else{
                this.showJdoctor = true;
            }
            let jDoctorUrl = window.location.href;
            let x = jDoctorUrl.indexOf('proDetails');
            let y = jDoctorUrl.indexOf('allPro');
            if(localStorage.source == 'jStore' && (x != -1 || y != -1)){
                this.showJdoctor = false;
            }
        },
        toJoinUpIndex(){
            let urll = window.location.href;
            let parms = urll.match('joinUpIndex');
            let path = 'joinUpIndex'
            if (parms == null) {
                this.$router.push({
                    name: path,
                    params: {paramId:'wx'}
                });
              localStorage.setItem("refresh", "refresh");
            }else{
                localStorage.setItem("refresh", "refresh");
                location.reload();
            }
        },
        isAppId(){
            if(localStorage.user_id){
                let user_id = localStorage.user_id;
                this.$http
                    .get(this.URL.application + '?user_id=' + user_id)
                    .then(res => {
                        this.appList = res.data.data;
                        if(res.data.data.length == 0){
                            this.wxAppId= false;
                        }else{
                            this.wxAppId= true;
                        }
                    })
            }
            return
        }
    },
    created() {
      this.getJumpType();
      this.isAppId();
      if(this.URL.systemName === '融创绵阳') {
        let data = this.tabs
        data.map((v, i) => {
          if (v.type === '首页' || v.type === '超级BP' || v.type === '小程序后台') {
              v.show = false
          }
        })
        this.tabs = data
      }
    },
  watch :{
    user_id(newData,oldData){
        this.isAppId()
    }
  }
};
</script>

<style lang="less">
#header {
  .logoIndex {
    margin: 5px 50px 0 50px;
    background: #fff;
    width: 46px;
    height: 46px;
    border-radius: 50%;
    img {
      width: 38px;
      height: 38px;
    }
  }
}
li.relative:hover {
  opacity: 1 !important;
  .text {
    opacity: 0.5;
  }
  .weixin {
    display: block;
  }
}
.weixin {
  display: none;
  position: absolute;
  z-index: 1;
  top: 20px;
  left: 300%;
  transform: translateX(-50%);
  background: #fff;
  box-shadow: 0 4px 4px 0 rgba(64, 88, 122, 0.1);
  border-radius: 4px;
  width: 227px;
  height: 296px;
  &::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -100%);
    border: 10px solid transparent;
    border-bottom-color: #fff;
  }
  p {
    font-size: 18px;
    color: #1f2d3d;
    line-height: 24px;
    text-align: center;
  }
  .img {
    margin: 0px 32px 32px;
    width: 162px;
    height: 162px;
    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topHeader.vue